import { render, staticRenderFns } from "./ChatNote.vue?vue&type=template&id=771617ad&scoped=true"
import script from "./ChatNote.vue?vue&type=script&lang=js"
export * from "./ChatNote.vue?vue&type=script&lang=js"
import style0 from "./ChatNote.vue?vue&type=style&index=0&id=771617ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771617ad",
  null
  
)

export default component.exports